import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  CommunicatorMessageType as MessageType,
  MessageTypeToTemplateMapping,
  Template,
} from '@quorum/models/xs-resource';
import { TemplatesFacade } from '@quorum/xsr-template-library';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'quorum-delete-template-dialog',
  templateUrl: './delete-template-dialog.component.html',
  styleUrls: ['./delete-template-dialog.component.scss'],
})
export class DeleteTemplateDialogComponent implements OnInit {
  deleteMessage: string;
  canDelete: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { template: Template }, private templateFacade: TemplatesFacade) {}

  ngOnInit(): void {
    combineLatest([this.templateFacade.messageTypeToTemplateMappings$, this.templateFacade.messageTypes$])
      .pipe(
        take(1),
        map(([messageTypeToTemplateMappings, messageTypes]): [MessageTypeToTemplateMapping, MessageType] => [
          messageTypeToTemplateMappings.find(
            (messageTypeToTemplateMapping) => messageTypeToTemplateMapping.templateId === this.data.template.id
          ),
          messageTypes.find((messageType) => messageType.id === this.data.template.messageTypeId),
        ])
      )
      .subscribe(([messageTypeToTemplateMapping, messageType]) => {
        if (messageTypeToTemplateMapping) {
          this.canDelete = false;
          this.deleteMessage = `This template is currently set as the default for a "${messageType.description}" and can not be deleted.`;
        } else {
          this.canDelete = true;
          this.deleteMessage = 'Are you sure you want to delete this template? This can not be undone.';
        }
      });
  }
}
